export * from './apiKeys.service';
import { ApiKeysService } from './apiKeys.service';
export * from './document.service';
import { DocumentService } from './document.service';
export * from './documentArea.service';
import { DocumentAreaService } from './documentArea.service';
export * from './documentMarkup.service';
import { DocumentMarkupService } from './documentMarkup.service';
export * from './documentSet.service';
import { DocumentSetService } from './documentSet.service';
export * from './documentStatus.service';
import { DocumentStatusService } from './documentStatus.service';
export * from './documentStorage.service';
import { DocumentStorageService } from './documentStorage.service';
export * from './documentStore.service';
import { DocumentStoreService } from './documentStore.service';
export * from './documentTag.service';
import { DocumentTagService } from './documentTag.service';
export * from './documentTagType.service';
import { DocumentTagTypeService } from './documentTagType.service';
export * from './documentTagTypeValue.service';
import { DocumentTagTypeValueService } from './documentTagTypeValue.service';
export * from './documentType.service';
import { DocumentTypeService } from './documentType.service';
export * from './documentVersion.service';
import { DocumentVersionService } from './documentVersion.service';
export * from './drawing.service';
import { DrawingService } from './drawing.service';
export * from './environment.service';
import { EnvironmentService } from './environment.service';
export * from './metadata.service';
import { MetadataService } from './metadata.service';
export const APIS = [ApiKeysService, DocumentService, DocumentAreaService, DocumentMarkupService, DocumentSetService, DocumentStatusService, DocumentStorageService, DocumentStoreService, DocumentTagService, DocumentTagTypeService, DocumentTagTypeValueService, DocumentTypeService, DocumentVersionService, DrawingService, EnvironmentService, MetadataService];
